<ion-header class="ion-no-border">
  <ion-toolbar mode="md">
    <ion-buttons slot="start">
      <ion-button
        (click)="cancel()"
        aria-label="Cancelar"
      >
        <ion-icon
          slot="icon-only"
          src="../assets/material-symbols/close_24dp.svg"
        ></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>{{ 'market.confirm_accept' | translate }}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <lib-freight-available-detail-modal-data [freight]="freight"></lib-freight-available-detail-modal-data>

  <ion-item class="ion-margin-horizontal-negative">
    <ion-checkbox
      labelPlacement="start"
      [(ngModel)]="isTermsChecked"
    >
      Acepto los términos y condiciones
    </ion-checkbox>
  </ion-item>

  @if (hasError && !isTermsChecked) {
    <div class="errors">
      {{ 'error.check_terms' | translate }}
    </div>
  }

  <!-- TODO translate this -->
  <p><strong>Resumen de los términos y condiciones</strong></p>
  <div class="fs-xs">
    <p>
      La aceptación de este servicio implica que como transportista efectivo ha leído y aceptado las condiciones
      generales que OkCargo establece para la aceptación del servicio y especialmente que los vehículos y conductores
      que van a prestar el servicio cumplen con la legislación vigente.
    </p>
    <p>
      Deberá disponer de un seguro de responsabilidad sobre la mercancía que cubra las especificaciones que la LOTT
      establece para el transporte nacional y convenio CMR en caso de transporte internacional.
    </p>
    <p>
      Los vehículos que realizan el servicio deben de estar limpios, secos, sin olor y en perfecto estado para la carga
      / descarga.
    </p>
    <p>
      Respetar fechas y horarios de carga y descarga, así como las indicaciones específicas descritas en la orden.
      Cualquier retraso o anomalía nos será notificada de inmediato en el número de teléfono: 915 560 075 Ext. 1
    </p>
    <p>
      El transportista efectivo es responsable de cualquier retraso, daño o pérdida que pueda sufrir la mercancía
      durante el periodo en que se encuentre ésta bajo su tutela, debiendo responder de las reclamaciones que se
      produzcan.
    </p>
    <p>Se prohíbe el transbordo o manipulación de la mercancía sin autorización de OkCargo</p>
    <p>
      Es imprescindible que la documentación asociada al servicio (albaranes, CMR, documento de control, etc..) estén
      subidos a nuestro sistema desde la app móvil que previamente habrás instalado en tu teléfono móvil. El pago del
      servicio no se liberará hasta que hayamos comprobado que dicha documentación está en nuestro sistema.
    </p>
    <p>Si no hemos recibido respuesta en contra, supone la aceptación de todos los términos descritos anteriormente.</p>
  </div>
</ion-content>

<ion-footer>
  <ion-toolbar>
    <ion-grid class="ion-padding-vertical-0">
      <ion-row>
        <ion-col>
          <ion-button
            (click)="confirm()"
            color="primary"
            expand="block"
            size="large"
            fill="solid"
          >
            <ion-icon
              slot="start"
              aria-hidden="true"
              src="../assets/material-symbols/check_24dp.svg"
            ></ion-icon>
            {{ 'general.confirm' | translate }}
          </ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-toolbar>
</ion-footer>
